export default __webpack_public_path__ + "643fb1f4045741c44afb0701d5224200.png";